import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Container,
  Card,
  Typography,
  TextField,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Grid,
  Tooltip,
  TablePagination,
} from "@mui/material";
import {
  Edit as EditIcon,
  Search as SearchIcon,
  Download as DownloadIcon,
  Block as BlockIcon,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";
import * as XLSX from "xlsx";
import BASE_URL from "../config";
const StudentsPage = () => {
  const [courses, setCourses] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);
  const [classes, setClasses] = useState([]);
  const [students, setStudents] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedStudents, setSelectedStudents] = useState([]);
const [feesCategories, setFeesCategories] = useState([]);
const [selectedCategory, setSelectedCategory] = useState("");
const [routes, setRoutes] = useState([]);
const [selectedRoute, setSelectedRoute] = useState("");
const [sections, setSections] = useState([]);
const [selectedSection, setSelectedSection] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    fetchCourses();
  }, []);
  const fetchCourses = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/coursesa`);
      setCourses(res.data);
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };
  const fetchAcademicYears = async (courseID) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/academicYears/${courseID}`);
      setAcademicYears(res.data);
    } catch (error) {
      console.error("Error fetching academic years:", error);
    }
  };
  const fetchClasses = async (courseID) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/classes?course=${courseID}`);
      setClasses(res.data);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };
  const fetchStudents = async () => {
     if (!selectedCourse || !selectedYear) {
    alert("Please select both Course and Academic Year.");
    return;
  }
    try {
      const params = {};
      if (selectedCourse) params.courseID = selectedCourse;
      if (selectedYear) params.academicYear = selectedYear;
      if (selectedClass) params.classID = selectedClass;
      if (selectedSection) params.sectionID = selectedSection;
      if (searchName) params.studentName = searchName;
      const res = await axios.get(`${BASE_URL}/api/getStudents`, { params });
      setStudents(res.data);
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };
  const handleCourseChange = (courseID) => {
    setSelectedCourse(courseID);
    setSelectedYear("");
    setSelectedClass("");
    if (courseID) {
      fetchAcademicYears(courseID);
      fetchClasses(courseID);
    } else {
      setAcademicYears([]);
      setClasses([]);
    }
  };
  const handleClassChange = async (classID) => {
  setSelectedClass(classID);
  setSelectedSection(""); // reset section when class changes
  if (classID) {
    try {
      const res = await axios.get(`${BASE_URL}/api/sections/${classID}`);
      if (res.data && res.data.length > 0) {
        setSections(res.data);
      } else {
        setSections([]); // no sections available
      }
    } catch (err) {
      console.error("Error fetching sections:", err);
    }
  } else {
    setSections([]);
  }
};
  const handleEdit = (studentID) => {
    navigate(`/edit-student/${studentID}`);
  };
  const handleToggleStatus = async (studentID, isActive) => {
    const newStatus = isActive ? 0 : 1;
    if (window.confirm(`Are you sure you want to mark this student as ${newStatus ? "Active" : "Inactive"}?`)) {
      try {
        await axios.put(`${BASE_URL}/api/toggleStudentStatus/${studentID}`, { isActive: newStatus });
        alert(`Student marked as ${newStatus ? "Active" : "Inactive"} successfully`);
        fetchStudents();
      } catch (error) {
        alert("Error updating student status");
        console.error("Error:", error);
      }
    }
  };
  const handleExportToExcel = () => {
    if (students.length === 0) {
      alert("There are no records to export.");
      return;
    }
    const exportData = students.map(
      ({ StudentID,StudentName, CourseName, AcademicYearName, ClassName,SectionName }) => ({
        "Student ID": StudentID,
        "Student Name": StudentName,
        "Course": CourseName,
        "Academic Year": AcademicYearName,
        "Class": ClassName,
        "Section":SectionName,
      })
    );
    // Create worksheet from student data
    const worksheet = XLSX.utils.json_to_sheet(exportData,{ origin: "A3" }); // Start from row 3
     //Add society and college names manually at the top
  XLSX.utils.sheet_add_aoa(worksheet, [
  ["Trust(R)"], // Row 1
    ["Chaitanya Model Techno School-Lingasugur"],   // Row 2
  ], { origin: "A1" });
  // Create workbook and append worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Students");
    // Export the file
    XLSX.writeFile(workbook, "Students.xlsx");
  };
  const fetchFeesCategories = async () => {
  try {
     if (!selectedCourse) {
      alert("Please select a Course to fetch fee categories.");
      return;
    }
    //const res = await axios.get(`${BASE_URL}/api/feesCategories?type=0`);
    const res = await axios.get(`${BASE_URL}/api/getNonRegularFeeCategoriess`, {
      params: { courseID: selectedCourse },
    });
    setFeesCategories(res.data);
  } catch (error) {
    console.error("Error fetching fees categories:", error);
  }
};
const handleSelectAll = (event) => {
  if (event.target.checked) {
    const allIds = students.map((s) => s.StudentID);
    setSelectedStudents(allIds);
    fetchFeesCategories();
  } else {
    setSelectedStudents([]);
    setSelectedCategory("");
  }
};
const handleSelectStudent = (studentID) => {
  let updatedSelection = [...selectedStudents];
  if (updatedSelection.includes(studentID)) {
    updatedSelection = updatedSelection.filter((id) => id !== studentID);
  } else {
    updatedSelection.push(studentID);
  }
  setSelectedStudents(updatedSelection);
  if (updatedSelection.length > 0) fetchFeesCategories();
  else {
    setSelectedCategory("");
  }
};
/* const handleUpdateCategory = async () => {
  if (selectedStudents.length === 0) {
    alert("Please select at least one student.");
    return;
  }
  if (!selectedCategory) {
    alert("Please select a category.");
    return;
  }
if (routes.length > 0 && !selectedRoute) {
  alert("Please select a route fee.");
  return;
}
  try {
    const res = await axios.post(`${BASE_URL}/api/checkExistingFees`, {
      studentIDs: selectedStudents,
      categoryID: selectedCategory,
    });

    if (res.data.exists) {
      //alert("Some students already have fees set for this category.");
      alert(res.data.message);
      
    } else {
      await axios.post(`${BASE_URL}/api/updateStudentFeesCategory`, {
        studentIDs: selectedStudents,
        categoryID: selectedCategory,
         routeID: selectedRoute,
        adminName : sessionStorage.getItem("adminName"), // Retrieve admin name from session storage
      });
      alert("Fees category updated successfully.");
      setSelectedStudents([]);
      setSelectedCategory("");
      fetchStudents();
    }
  } catch (error) {
    console.error("Error updating category:", error);
    alert("Failed to update category.");
  }
}; */
const handleUpdateCategory = async () => {
  if (selectedStudents.length === 0) {
    alert("Please select at least one student.");
    return;
  }
  if (!selectedCategory) {
    alert("Please select a category.");
    return;
  }
  if (routes.length > 0 && !selectedRoute) {
    alert("Please select a route fee.");
    return;
  }
  try {
    const res = await axios.post(`${BASE_URL}/api/checkExistingFees`, {
      studentIDs: selectedStudents,
      categoryID: selectedCategory,
    });
    const { exists, alreadyAssigned, unassignedIDs, message } = res.data;

    if (exists) {
      alert(message); // Inform about already assigned students
    }
    if (unassignedIDs && unassignedIDs.length > 0) {
      await axios.post(`${BASE_URL}/api/updateStudentFeesCategory`, {
        studentIDs: unassignedIDs,
        categoryID: selectedCategory,
        routeID: selectedRoute,
        adminName: sessionStorage.getItem("adminName"),
      });
      alert("Fees category updated for unassigned students.");
      setSelectedStudents([]);
      setSelectedCategory("");
      fetchStudents();
    } else if (!exists) {
      alert("All selected students already have the category assigned.");
    }
  } catch (error) {
    console.error("Error updating category:", error);
    alert("Failed to update category.");
  }
};
const handleCategoryChange = async (categoryID) => {
  setSelectedCategory(categoryID);
  setSelectedRoute(""); // Clear previous route selection
  if (categoryID) {
    try {
      const res = await axios.get(`${BASE_URL}/api/getRouteDetails/${categoryID}`);
      //const distinctRoutes = getDistinctRoutesByFee(res.data);
      //setRoutes(distinctRoutes);
      setRoutes(res.data);
    } catch (err) {
      console.error("Error fetching route details:", err);
    }
  } else {
    setRoutes([]);
  }
};
const handleDeleteStudents = async () => {
  if (selectedStudents.length === 0) {
    alert("Please select at least one student.");
    return;
  }
  const confirm = window.confirm(
    `Are you sure you want to delete ${selectedStudents.length} selected student(s)? This action cannot be undone.`
  );
  if (!confirm) return;
  try {
    const response = await axios.post(`${BASE_URL}/api/deleteStudents`, {
      studentIDs: selectedStudents,
      deletedBy : sessionStorage.getItem("adminName"),
    });
    alert(response.data.message || "Deleted successfully.");
    // Refresh students list
    fetchStudents();
    setSelectedStudents([]);
    setSelectedCategory("");
  } catch (err) {
    console.error("Delete Error:", err);
    alert("Failed to delete students.");
  }
};
/* const handleUpdateSection = async () => {
  try {
    const payload = {
      studentIDs: selectedStudents,
      courseID: selectedCourse,
      academicYearID: selectedYear,
      classID: selectedClass,
      sectionID: selectedSection
    };

    const res = await axios.post(`${BASE_URL}/checkAssignedSection`, payload);
let assignedIDs = [];
    let assignedMessages = [];
    if (res.data.exists && res.data.conflicts.length > 0) {
      const conflictMsg = res.data.conflicts
        .map(
          (c) =>
            `Already assigned ${c.SectionName} of ${c.ClassName} for ${c.StudentName}`
        )
        .join(", ");
      alert(conflictMsg);
    } else {
      // Proceed to update
      const updateRes = await axios.post(`${BASE_URL}/updateStudentSection`, payload);
      if (updateRes.data.success) {
        alert("Section successfully assigned to selected students.");
        fetchStudents(); // Refresh table
      } else {
        alert("Failed to update section.");
      }
    }
  } catch (err) {
    console.error("Section update error:", err);
    alert("An error occurred. Please try again.");
  }
}; */

// Helper: get unique routes by fee
/* const getDistinctRoutesByFee = (data) => {
  const seenFees = new Set();
  return data.filter((route) => {
    if (!seenFees.has(route.Fee)) {
      seenFees.add(route.Fee);
      return true;
    }
    return false;
  });
}; */

const handleUpdateSection = async () => {
  try {
    const payload = {
      studentIDs: selectedStudents,
      courseID: selectedCourse,
      academicYearID: selectedYear,
      classID: selectedClass,
      sectionID: selectedSection
    };

    const res = await axios.post(`${BASE_URL}/api/checkAssignedSection`, payload);

    let assignedIDs = [];
    let assignedMessages = [];

    if (res.data.exists && res.data.conflicts.length > 0) {
      assignedIDs = res.data.conflicts.map((c) => c.StudentID);
      assignedMessages = res.data.conflicts.map(
        (c) =>
          `Already assigned ${c.SectionName} of ${c.ClassName} for ${c.StudentName}`
      );
    }

    const unassignedIDs = selectedStudents.filter(
      (id) => !assignedIDs.includes(id)
    );

    if (assignedMessages.length > 0) {
      alert(assignedMessages.join(", "));
    }

    if (unassignedIDs.length === 0) {
      return; // All were already assigned
    }

    // Proceed to update unassigned students only
    const updatePayload = {
      ...payload,
      studentIDs: unassignedIDs,
    };

    const updateRes = await axios.post(`${BASE_URL}/api/updateStudentSection`, updatePayload);

    if (updateRes.data.success) {
      alert("Section successfully assigned to remaining unassigned students.");
      fetchStudents(); // Refresh table
      setSelectedStudents([]); // Optional: reset selection
    } else {
      alert("Failed to update section.");
    }
  } catch (err) {
    console.error("Section update error:", err);
    alert("An error occurred. Please try again.");
  }
};

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Card sx={{ p: 4, boxShadow: 3 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Manage Students
        </Typography>
        {/* Filters */}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              select
              fullWidth
              label="Select Course"
              value={selectedCourse || ""}
              onChange={(e) => handleCourseChange(e.target.value)}
            >
              <MenuItem value="">-- Select Course --</MenuItem>
              {courses.length > 0 ? (
                courses.map((course) => (
                  <MenuItem key={course.CourseID} value={course.CourseID}>
                    {course.CourseName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>No courses available</MenuItem>
              )}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              select
              fullWidth
              label="Select Academic Year"
              value={selectedYear || ""}
              onChange={(e) => setSelectedYear(e.target.value)}
              disabled={!selectedCourse || academicYears.length === 0}
            >
              <MenuItem value="">-- Select Academic Year --</MenuItem>
              {academicYears.length > 0 ? (
                academicYears.map((year) => (
                  <MenuItem key={year.AcademicYearID} value={year.AcademicYearID}>
                    {year.AcademicYearName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>No academic years available</MenuItem>
              )}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              select
              fullWidth
              label="Select Class"
              value={selectedClass || ""}
              /* onChange={(e) => setSelectedClass(e.target.value)} */
               onChange={(e) => handleClassChange(e.target.value)}
              disabled={!selectedCourse || classes.length === 0}
            >
              <MenuItem value="">-- Select Class --</MenuItem>
              {classes.length > 0 ? (
                classes.map((cls) => (
                  <MenuItem key={cls.id || cls.ClassID} value={cls.id || cls.ClassID}>
                    {cls.name || cls.ClassName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>No classes available</MenuItem>
              )}
            </TextField>
          </Grid>
          {sections.length > 0 && (
  <Grid item xs={12} sm={4}>
    <TextField
      select
      fullWidth
      label="Select Section"
      value={selectedSection || ""}
      onChange={(e) => setSelectedSection(e.target.value)}
    >
      <MenuItem value="">-- Select Section --</MenuItem>
      {sections.map((sec) => (
        <MenuItem key={sec.SectionID} value={sec.SectionID}>
          {sec.SectionName}
        </MenuItem>
      ))}
    </TextField>
  </Grid>
)}

{selectedSection && selectedStudents.length > 0 && (
  <Button
    variant="contained"
    color="primary"
    onClick={handleUpdateSection}
    sx={{ mt: 2 }}
  >
    Update Section
  </Button>
)}

          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Search Student Name/ID"
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={fetchStudents}
              startIcon={<SearchIcon />}
            >
              Search
            </Button>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button
              fullWidth
              variant="contained"
              color="success"
              onClick={handleExportToExcel}
              startIcon={<DownloadIcon />}
            >
              Export to Excel
            </Button>
          </Grid>
          {selectedStudents.length > 0 && (
  <>
    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        select
        label="Select Category"
        value={selectedCategory}
        onChange={(e) => handleCategoryChange(e.target.value)}
      >
        <MenuItem value="">-- Select Category --</MenuItem>
        {feesCategories.map((cat) => (
          <MenuItem key={cat.CategoryID} value={cat.CategoryID}>
            {cat.CategoryName}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
     {/* Conditionally Render Route Dropdown */}
  {routes.length > 0 && (
    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        select
        label="Select Route Fee"
        value={selectedRoute}
        onChange={(e) => setSelectedRoute(e.target.value)}
      >
        <MenuItem value="">-- Select Fee --</MenuItem>
        {routes.map((route) => (
          <MenuItem key={route.RouteID} value={route.RouteID}>
            ₹ {route.Fee} - {route.RouteName}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
  )}


    <Grid item xs={12} sm={6}>
      <Button
        variant="contained"
        color="secondary"
        fullWidth
        disabled={!selectedCategory}
        onClick={handleUpdateCategory}
      >
        Update
      </Button>
    </Grid>
     <Grid item xs={12} sm={6}>
     <Button
    variant="contained"
    color="error"
    sx={{ mt: 2 }}
    onClick={handleDeleteStudents}
  >
    Delete Selected Students
  </Button>
  </Grid>
  </>
)}
        </Grid>
      </Card>
      {/* Students Table */}
      <TableContainer component={Paper} sx={{ mt: 4 }}>
        <Table>
          <TableHead sx={{ backgroundColor: "#1976D2" }}>
            <TableRow>
              <TableCell padding="checkbox">
  <input
    type="checkbox"
    checked={
      students.length > 0 &&
      selectedStudents.length === students.length
    }
    onChange={handleSelectAll}
  />
</TableCell>
              <TableCell sx={{ color: "white" }}>Student ID</TableCell>
              <TableCell sx={{ color: "white" }}>Student Name</TableCell>
              <TableCell sx={{ color: "white" }}>Course</TableCell>
              <TableCell sx={{ color: "white" }}>Academic Year</TableCell>
              <TableCell sx={{ color: "white" }}>Class</TableCell>
               <TableCell sx={{ color: "white" }}>Section</TableCell>
              <TableCell sx={{ color: "white" }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {students.length > 0 ? (
              students
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((student) => (
                  <TableRow key={student.StudentID}>
                    <TableCell padding="checkbox">
    <input
      type="checkbox"
      checked={selectedStudents.includes(student.StudentID)}
      onChange={() => handleSelectStudent(student.StudentID)}
    />
  </TableCell>
                    <TableCell>{student.StudentID}</TableCell>
                    <TableCell>{student.StudentName}</TableCell>
                    <TableCell>{student.CourseName}</TableCell>
                    <TableCell>{student.AcademicYearName}</TableCell>
                    <TableCell>{student.ClassName}</TableCell>
                     <TableCell>{student.SectionName}</TableCell>
                    <TableCell>
                      <Tooltip title="Edit">
                        <IconButton
                          color="warning"
                          onClick={() => handleEdit(student.StudentID)}
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        title={student.IsActive ? "Mark as Inactive" : "Mark as Active"}
                      >
                        <IconButton
                          color={student.IsActive ? "success" : "error"}
                          onClick={() => handleToggleStatus(student.StudentID, student.IsActive)}
                        >
                          {student.IsActive ? <CheckCircleIcon /> : <BlockIcon />}
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No students found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={students.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
        />
      </TableContainer>
    </Container>
  );
};
export default StudentsPage;
